<template>
<CustomField v-bind="{ id, label, error }" class="custom-input">
  <template slot="default" slot-scope="scopeProps">
    <input
      v-bind="$attrs"
      v-on="listenersToPass"
      :value="value"
      @input="$emit('input', $event.target.value)"
      :type="type"
      :id="scopeProps.id"
      class="form-control"
    >
    <slot></slot>
  </template>
</CustomField>
</template>

<script>
import CustomField from './CustomField'

export default {
  inheritAttrs: false,

  components: { CustomField },

  props: {
    // Same props as in CustomField, so we can pass them to CustomField, and pass `$attrs` to the input.
    id: {}, label: {}, error: {},
    value: {},
    type: {
      type: String,
      default: 'text',
    }
  },

  computed: {
    listenersToPass() {
      const toPass = { ...this.$listeners };
      delete toPass.input;
      return toPass;
    }
  }
}
</script>
